import Decimal from 'decimal.js';
import { Maths } from 'helpers/maths';

export const roundPercentToArea = (percent, area, round = 2) => {
  return Maths.parseFloatRound(
    Maths.multiply(Maths.divide(percent, 100), area),
    round,
    Decimal.ROUND_HALF_UP
  );
};

export const roundAreaToPercent = (area, totalArea, round = 2) => {
  return Maths.parseFloatRound(
    Maths.multiply(Maths.divide(area, totalArea), 100),
    round,
    Decimal.ROUND_HALF_UP
  );
};
